/**
 * 应用级 Cookie 前缀
 *
 * Better Auth（后端）使用此值作为 cookiePrefix（格式：${prefix}.session_token）
 * 其他 cookie 使用此值作为命名空间前缀（格式：${prefix}.locale）
 *
 * 可通过 VITE_COOKIE_PREFIX 环境变量覆盖，默认值 'tb2'
 * ⚠️ MUST match: apps/api/src/lib/auth.ts → advanced.cookiePrefix (env.COOKIE_PREFIX)
 */
export const APP_COOKIE_PREFIX = import.meta.env.VITE_COOKIE_PREFIX || 'tb2'

/**
 * 从统一前缀派生的所有 cookie 名称
 */
export const COOKIE_NAMES = {
  /** Better Auth session token cookie (由后端 cookiePrefix 配置控制) */
  sessionToken: `${APP_COOKIE_PREFIX}.session_token`,
  /** i18n locale 偏好 */
  locale: `${APP_COOKIE_PREFIX}.locale`,
  /** UI 主题偏好 */
  theme: `${APP_COOKIE_PREFIX}.theme`,
}
